import clsx from 'clsx';
import { CheckCircleIcon, ClockIcon } from '@heroicons/react/24/outline';
import { formatDateSafe } from '@/utils/dateUtils';
import { TOOLBAR_LABELS } from '../approvals.definitions';

interface ApprovalQueueToolbarProps {
    pendingCount: number;
    oldestPendingAt?: Date | null;
}

export function ApprovalQueueToolbar({
    pendingCount,
    oldestPendingAt,
}: ApprovalQueueToolbarProps) {
    const isAllDone = pendingCount === 0;

    return (
        <div className="flex flex-wrap items-center gap-x-6 gap-y-4 rounded-2xl border border-primary-100 bg-white px-5 py-4 shadow-sm">
            <div className="flex items-center gap-3">
                <span
                    className={clsx(
                        'flex h-11 w-11 shrink-0 items-center justify-center rounded-full',
                        isAllDone ? 'bg-emerald-50 text-emerald-600' : 'bg-amber-50 text-amber-600'
                    )}
                    aria-hidden="true"
                >
                    {isAllDone ? (
                        <CheckCircleIcon className="h-6 w-6" />
                    ) : (
                        <ClockIcon className="h-6 w-6" />
                    )}
                </span>

                <div>
                    {isAllDone ? (
                        <>
                            <p className="text-sm font-semibold text-raro-gray-900 font-montserrat">
                                {TOOLBAR_LABELS.allDone}
                            </p>
                            <p className="text-xs text-raro-gray-500 font-montserrat">
                                {TOOLBAR_LABELS.allDoneHint}
                            </p>
                        </>
                    ) : (
                        <>
                            <p className="flex items-baseline gap-1.5">
                                <span className="text-2xl font-bold leading-none text-primary-600 font-montserrat">
                                    {pendingCount}
                                </span>
                                <span className="text-sm text-raro-gray-700 font-montserrat">
                                    {TOOLBAR_LABELS.pending(pendingCount)}
                                </span>
                            </p>
                            {oldestPendingAt && (
                                <p className="mt-0.5 text-xs text-raro-gray-500 font-montserrat">
                                    {TOOLBAR_LABELS.oldest(formatDateSafe(oldestPendingAt))}
                                </p>
                            )}
                        </>
                    )}
                </div>
            </div>

        </div>
    );
}

export default ApprovalQueueToolbar;
